import api from '../config/api';
import {
  FETCH_CRONS_LOADING,
  FETCH_CRONS_SUCCESS,
  FETCH_CRONS_ERROR,
  CREATE_CRON_LOADING,
  CREATE_CRON_SUCCESS,
  CREATE_CRON_ERROR,
  DELETE_CRON_LOADING,
  DELETE_CRON_SUCCESS,
  DELETE_CRON_ERROR
} from '../Types/cronTypes';

const API_WP = process.env.REACT_APP_API_URL;

export const getCrons = () => {
  return dispatch => {
    dispatch({ type: FETCH_CRONS_LOADING });
    return api
      .get(`${API_WP}Cron/get`)
      .then(response => {
        const data = Array.isArray(response.data) ? response.data : [];
        dispatch({ type: FETCH_CRONS_SUCCESS, payload: data });
        return data;
      })
      .catch(error => {
        dispatch({ type: FETCH_CRONS_ERROR, payload: error.message });
        throw new Error(error.message);
      });
  };
};

export const manageCron = (cronData: any) => {
  return dispatch => {
    dispatch({ type: CREATE_CRON_LOADING });
    return api
      .post(`${API_WP}Cron/manageCron`, cronData)
      .then(response => {
        console.log('manageCron response:', response.data);
        dispatch({ type: CREATE_CRON_SUCCESS, payload: { ...cronData, _id: response.data.id } });
        return response.data;
      })
      .catch(error => {
        console.error('manageCron error:', error.message);
        dispatch({ type: CREATE_CRON_ERROR, payload: error.message });
        throw new Error(error.message);
      });
  };
};

export const deleteCron = (cronId: string) => {
  return dispatch => {
    dispatch({ type: DELETE_CRON_LOADING });
    return api
      .delete(`${API_WP}Cron/deleteCron/${cronId}`)
      .then(response => {
        console.log('deleteCron response:', response.data);
        dispatch({ type: DELETE_CRON_SUCCESS, payload: cronId });
        return response.data;
      })
      .catch(error => {
        console.error('deleteCron error:', error.message);
        dispatch({ type: DELETE_CRON_ERROR, payload: error.message });
        throw new Error(error.message);
      });
  };
};

export const getCronsByType = type => {
  return dispatch => {
    dispatch({ type: FETCH_CRONS_LOADING });
    return api
      .get(`${API_WP}Cron/getByType/${type}`)
      .then(response => {
        const data = Array.isArray(response.data) ? response.data : [];
        dispatch({ type: FETCH_CRONS_SUCCESS, payload: data });
        return data;
      })
      .catch(error => {
        dispatch({ type: FETCH_CRONS_ERROR, payload: error.message });
        throw new Error(error.message);
      });
  };
};
